import { space } from '@synoptic/ui-kit/tokens.js';
import { style } from '@vanilla-extract/css';

export const deleteConfirmationActions = style({
  display: 'flex',
  marginTop: space.s32,
  gap: space.s16,
  justifyContent: 'end',
});

export const actionFollow = style({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
